import { useRef } from "react";
import { getQuantityCellsBySchedule } from "views/components/Schedules/utils/helpers";
import useUpdateActivityPopupWithExitConfirmation from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopupWithExitConfirmation";
import ScheduleActivity from "../components/ScheduleActivity";
import RegularReservationView from "./RegularReservationView";

const RegularReservationActivity = ({
	data, space, reservation
}) => {
	const { schedule } = reservation;
	const responsibleStudent = reservation.students.responsible;
	const quantityCells = getQuantityCellsBySchedule(schedule);
    const $activity = useRef();
	const updateActivityPopup = useUpdateActivityPopupWithExitConfirmation({
        $activity
    });
	return (
		<ScheduleActivity
			classList={["presential"]}
			header={{
				title: responsibleStudent.name,
				subtitle: responsibleStudent.id
			}}
			quantityCells={quantityCells}
			reservation={reservation}
			$activity={$activity}
			updateActivityPopup={updateActivityPopup}>
			<RegularReservationView
				data={data}
				space={space}
				updateActivityPopup={updateActivityPopup}
				reservation={reservation}/>
		</ScheduleActivity>
	);
}

export default RegularReservationActivity;